class SessionExpirationEmitter extends EventTarget {
  private static instance: SessionExpirationEmitter

  private constructor() {
    super()
  }

  static getInstance(): SessionExpirationEmitter {
    if (!this.instance) {
      this.instance = new SessionExpirationEmitter()
    }
    return this.instance
  }

  emit(): void {
    this.dispatchEvent(new Event("session-expired"))
  }

  onSessionExpired(listener: () => void): () => void {
    this.addEventListener("session-expired", listener)
    return () => {
      this.removeEventListener("session-expired", listener)
    }
  }
}

export const sessionExpirationEmitter = SessionExpirationEmitter.getInstance()
